import { Component, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { ToastService } from '@services/common/toast.service';
import { UserAction, UserStatus } from '@state/user.state';
import { AuthenticationService, CognitoAuthenticationService } from 'app/auth/service';
import { CustomValidators } from 'app/main/helpers/custom-validators';
import { Auth } from 'aws-amplify';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
    formGroup: FormGroup;
    loading: boolean = false;

    //Terms and conditions handeling
    public termsAccepted: boolean = false;

    constructor(
        private _formBuilder: UntypedFormBuilder,
        private authService: AuthenticationService,
        private router: Router,
        private route: ActivatedRoute,
        private _toastService: ToastService,
        private translateService: CustomTranslateService,
        private readonly cognitoAuthenticationService: CognitoAuthenticationService,
        private store: Store,
    ) {}

    ngOnInit(): void {
        this.initializeForm();
    }

    onSubmit() {
        this.formGroup.get('email')?.dirty;
        if (!this.formGroup.valid) return; // failsafe
        const email: string = this.formGroup.get('email')!.value;
        const firstName: string = this.formGroup.get('firstName')!.value;
        const lastName: string = this.formGroup.get('lastName')!.value;
        const password: string = this.formGroup.get('password')!.value;
        const companyName: string = this.formGroup.get('companyName')!.value;
        const language: string = this.translateService.currentLang;
        this.loading = true;
        this.authService.signUp(email, password, firstName, lastName, language, companyName).subscribe({
            next: (username) => {
                this.loading = false;
                this.authService.beginValidation(username, password);
                this.router.navigate(['auth', 'verification'], { relativeTo: this.route.root });
                this.store.dispatch(new UserAction.UpdateUserStatus(UserStatus.TERMS));
            },
            error: (err) => {
                if (err.code === 'UsernameExistsException') {
                    this._toastService.showError({
                        details: 'authentication.register.errors.userExists',
                        life: 5000,
                    });
                } else if (err.code === 'NetworkError') {
                    this._toastService.showError({
                        details: 'common.networkError',
                        life: 5000,
                    });
                } else {
                    this._toastService.showError({
                        details: 'common.error',
                        life: 5000,
                    });
                }
                this.loading = false;
            },
        });
    }

    private initializeForm() {
        this.formGroup = this._formBuilder.group(
            {
                firstName: ['', Validators.required],
                lastName: ['', Validators.required],
                companyName: ['', Validators.required],
                email: ['', [Validators.required, Validators.email]],
                password: ['', [Validators.required, CustomValidators.passwordValidator]],
                confirmPassword: ['', Validators.required],
            },
            {
                validators: [CustomValidators.mustMatch('password', 'confirmPassword')],
            },
        );

        this.formGroup.get('email')?.valueChanges.subscribe((value) => {
            if (value) {
                const lowerCaseValue = value.toLowerCase();
                if (value !== lowerCaseValue) {
                    this.formGroup.get('email')?.setValue(lowerCaseValue, { emitEvent: false });
                }
            }
        });
    }
}
